import { HawkSearchComponents, TooltipComponentConfig, TooltipComponentModel } from '@models';
import { BaseComponent } from '../../base.component';
import defaultHtml from './tooltip.component.hbs';

export class TooltipComponent extends BaseComponent<TooltipComponentConfig, string, TooltipComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'tooltip';
    protected override defaultHtml = defaultHtml;
    protected override bindFromEvent = false;

    private get text(): string | undefined {
        return this.getAttribute('text') ?? undefined;
    }

    protected override renderContent(): boolean {
        return !!this.text;
    }

    protected override getContentModel(): TooltipComponentModel {
        return {
            text: this.text!
        };
    }

    protected bindChildElements(): void {
        this.rootElement.querySelector('[hawksearch-tooltip]')?.addEventListener('mouseover', (event: Event) => {
            const element = event.currentTarget as HTMLElement;
            const contentElement = this.rootElement.querySelector('[hawksearch-tooltip-content]') as HTMLElement;

            if (!contentElement) {
                return;
            }

            contentElement.style.removeProperty('top');
            contentElement.style.removeProperty('right');

            const windowWidth = window.innerWidth;
            const boundingRect = element.getBoundingClientRect();
            const rightPosition = boundingRect.x + boundingRect.width;
            const maxWidth = 350;
            const margin = 20;

            contentElement.style.top = `${boundingRect.top}px`;

            if (windowWidth - rightPosition < maxWidth + margin) {
                contentElement.style.right = `${margin}px`;
            }
        });
    }
}
